import React, { useState, useRef } from "react";
import SwiperCore, { Navigation, Pagination, A11y } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import { NavLink } from "react-router-dom";
import "swiper/swiper-bundle.min.css";
import "styles/DestinationsCarousel.css";
import categories from "assets/categories.json";
import { ReactComponent as BgLines } from "assets/patterns/Textura.svg";
import hoteles from "assets/HotelesNacionales.json";


// Instalar módulos de Swiper
SwiperCore.use([Navigation, Pagination, A11y]);

// Combinar todas las ofertas de todas las categorías
const getAllOffers = () => {
    const destinosActivos = new Set(
    hoteles.HotelesNacionales.map((hotel) => hotel.Destino?.toUpperCase())
  );

  const allOffers = [];
  categories.forEach((category) => {
    if (category.list && category.list.length > 0) {
      category.list.forEach((hotel) => {
        if (destinosActivos.has(hotel.Ciudad?.toUpperCase())) {
          allOffers.push({
            ...hotel,
            category: category.title,
          });
        }
      });
    }
  });
  return allOffers
};

const DestinationsCarousel = () => {
  const allOffers = getAllOffers();
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  // Calcular cuántos "grupos" de slides hay (para los bullets)
  const totalSlides = allOffers.length;
  const maxBullets = 7; // Máximo de bullets visibles
  const bulletCount = Math.min(totalSlides, maxBullets);

  return (
    <section className="destinations-carousel">
      <BgLines className="bg-icon" />

      <div className="destinations-carousel__container">
        {/* Lado izquierdo - Título y descripción */}
        <div className="destinations-carousel__info">
          <h2 className="destinations-carousel__title">Nuestros destinos</h2>
          <p className="destinations-carousel__description">
            La combinación perfecta entre destinos de ensueño y emociones que
            transforman.
          </p>
        </div>

        {/* Lado derecho - Carrusel */}
        <div className="destinations-carousel__slider">
          <Swiper
            spaceBetween={20}
            slidesPerView={1.2}
            centeredSlides={false}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
            navigation={{
              prevEl: ".destinations-carousel__nav--prev",
              nextEl: ".destinations-carousel__nav--next",
            }}
            breakpoints={{
              480: {
                slidesPerView: 1.5,
                spaceBetween: 15,
              },
              640: {
                slidesPerView: 2.2,
                spaceBetween: 20,
              },
              900: {
                slidesPerView: 3.2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 3.5,
                spaceBetween: 25,
              },
            }}
            className="destinations-carousel__swiper"
          >
            {allOffers.map((hotel, index) => (
              <SwiperSlide key={index}>
                <NavLink to="/hoteles" className="destinations-carousel__card">
                  <div className="destinations-carousel__image-wrapper">
                    <img
                      src={hotel.Image}
                      alt={hotel.Hotel}
                      className="destinations-carousel__image"
                    />
                  </div>
                  <div className="destinations-carousel__card-footer">
                    <span className="destinations-carousel__card-city">
                      {hotel.Ciudad}
                    </span>
                    <svg
                      className="destinations-carousel__card-arrow"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        d="M9 5l7 7-7 7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </NavLink>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Navegación personalizada con pagination en medio */}
          <div className="destinations-carousel__controls">
            <button
              className="destinations-carousel__nav destinations-carousel__nav--prev"
              aria-label="Anterior"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  d="M15 19l-7-7 7-7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="destinations-carousel__pagination">
              {Array.from({ length: bulletCount }).map((_, index) => {
                // Calcular qué bullet está "activo" basado en la posición actual
                const progress = activeIndex / (totalSlides - 1);
                const activeBulletIndex = Math.round(
                  progress * (bulletCount - 1)
                );
                const isActive = index === activeBulletIndex;
                const distance = Math.abs(index - activeBulletIndex);

                return (
                  <span
                    key={index}
                    className={`destinations-carousel__bullet ${
                      isActive ? "destinations-carousel__bullet--active" : ""
                    }`}
                    data-distance={distance}
                    onClick={() => {
                      const slideIndex = Math.round(
                        (index / (bulletCount - 1)) * (totalSlides - 1)
                      );
                      swiperRef.current?.slideTo(slideIndex);
                    }}
                  />
                );
              })}
            </div>
            <button
              className="destinations-carousel__nav destinations-carousel__nav--next"
              aria-label="Siguiente"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  d="M9 5l7 7-7 7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DestinationsCarousel;
